import { Component } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';

import { DarkPoolService } from '../dark-pool.service';
import { AuthService } from '../../../../components/auth/auth.service';

import moment from 'moment-timezone';
import { timer } from 'd3';

@Component({
  selector: 'dark-pool-check-contact',
  template: require('./dark-pool-check-contact.html')
})
export class DarkPoolCheckContactComponent {
  static parameters = [BsModalRef, DarkPoolService, AuthService];
  constructor(bsModalRef: BsModalRef, darkPoolService: DarkPoolService, authService: AuthService) {
    this.bsModalRef = bsModalRef;
    this.darkPoolService = darkPoolService;
    this.authService = authService;
    this.eloquaContactId = '';
    this.analyzedContactId = '';
    this.results = null;
    this.loading = false;
    this.contactBreakdownLabels = this.darkPoolService.getContactBreakdownLabels();
  }

  checkContact() {
    this.loading = true;
    this.results = null;
    this.analyzedContactId = this.eloquaContactId;

    this.authService.getCurrentOrg().then(org => {
      if(typeof org !== 'undefined') {
        this.currentOrg = org;

        this.darkPoolService.getDarkPoolTimeRange(this.currentOrg._id).then(timeRange => {
          this.darkPoolService.checkContact(timeRange.start_date, timeRange.end_date, this.eloquaContactId).then(data => {
            this.loading = false;
            this.results = data;
            //console.log('----> results:', this.results); //debug
          });
        });
      }
    });
  }

  done() {
    this.bsModalRef.hide();
  }
}
